import React from 'react'
import Text from '../../../_components/Text'

export default props => {
    return <div className="container">
        <div className="row">
            <div className="col-12">
                <Text color="primary" className="text-center h2 py-3">
                    Página em desenvolvimento ...
                </Text>
                <Text className="text-center h5" color="primary">
                    Este recurso está em desenvolvimento
                </Text>
            </div>
        </div>
    </div>
}


// WEBPACK FOOTER //
// ./src/views/AppViews/BuildingPage/index.jsx